import React, {useEffect, useState, useRef} from 'react';
import {useFormContext, useFieldArray, useWatch} from 'react-hook-form';
import {companyPropTypes, companyDefaultProps} from './panelProps';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import * as allConstants from '../../../constants/allConstants';
import Grid from '@mui/material/Grid';
import {Box, Card, CardContent, List, Typography, ListItem, FormControl} from '@mui/material';
import {useCompanyPageStyles} from '../companyPageStyles';
import {globalUseClasses} from '../../../styles/globalClasses';
import {inputTypes} from '../../../pieces/inputs/formInput';
import Utils from '../../../utils/utils';
import base_url from '../../../baseUrls';
import {NotAllowedToEditSection} from './notAllowedToEditSection';
import {AddRowButton, DeleteEquipmentRowButton, DeleteRowButton, variants} from '../../../pieces/addDeleteEquipmentRowButtons';
import { AutoCompleteComponent} from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data';
//import {FloatingLabel} from '../../../pieces/inputs/customInputComponent';
//import {useAutocompleteOptions} from '../../../hooks/useAutompleteOptions';
import ApiUtils from '../../../utils/apiUtils';
import './companySettings.css'
import { DAYS_OF_WEEK } from '../../../constants/options/calendarOptions';
import { AUTO_HOLD_JOB_TYPES, INSPECTION_LIMIT_TYPES, JOB_TYPES } from '../../../constants/options/jobTypes';
import {COMPANY_ELEMENTS, companyRules} from '../../../permissions/companyAccessControl';
import {resolveCallbackDaysValue, resolveMaxNoAnswerAttemptsValue} from '../../../constants/formFields/companyFields';
import {NewPermissionGate} from '../../../permissions/permissionGate';

import Spacer from '../../../pieces/spacer';

export const CompanyInspectionInfo = (props)=> {
  const [init] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const classes = {...useCompanyPageStyles(), ...globalUseClasses()};
  const COMPANY_FIELDS = allConstants.COMPANY_FIELDS;

  //let authToken = useRef(null);
  const formMethods = useFormContext();

  const companyDataId = props.tabProps?.companyData?.[COMPANY_FIELDS.ID.api_name] ?? props.tabProps?.companyData?.id;
  const allowAiCallValue = useWatch({
    control: formMethods.control,
    name: COMPANY_FIELDS.ALLOW_AI_CALL.api_name,
  });
  const prevAllowAiCallRef = useRef(allowAiCallValue);
  const skipAllowAiCallChangeRef = useRef(true);
  const baselineAllowAiCallRef = useRef();
  const baselineAllowAiCallUpdatedUserRef = useRef('');
  const baselineAllowAiCallUpdatedAtRef = useRef('');

  const normalizeAllowAiCallForCompare = (v) => {
    if (v === '' || v === null || v === undefined) {
      return undefined;
    }
    return v;
  };

  const formatAllowAiCallUpdatedAtDisplay = (raw) => {
    if (raw == null || raw === '') {
      return '';
    }
    return Utils.formatIsoDateString(String(raw).trim(), {date: true});
  };

  useEffect(() => {
    skipAllowAiCallChangeRef.current = true;
    const cd = props.tabProps?.companyData || {};
    baselineAllowAiCallRef.current = cd[COMPANY_FIELDS.ALLOW_AI_CALL.api_name];
    const rawUpdatedUser = cd[COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_USER.api_name];
    baselineAllowAiCallUpdatedUserRef.current = rawUpdatedUser == null ? '' : String(rawUpdatedUser);
    const rawUpdatedAt = cd[COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_AT.api_name];
    baselineAllowAiCallUpdatedAtRef.current = formatAllowAiCallUpdatedAtDisplay(rawUpdatedAt);
    prevAllowAiCallRef.current = formMethods.getValues(COMPANY_FIELDS.ALLOW_AI_CALL.api_name);
  }, [companyDataId, formMethods]);

  useEffect(() => {
    if (skipAllowAiCallChangeRef.current) {
      skipAllowAiCallChangeRef.current = false;
      prevAllowAiCallRef.current = allowAiCallValue;
      return;
    }
    if (prevAllowAiCallRef.current === allowAiCallValue) {
      return;
    }
    prevAllowAiCallRef.current = allowAiCallValue;

    const baselineCall = normalizeAllowAiCallForCompare(baselineAllowAiCallRef.current);
    const currentCall = normalizeAllowAiCallForCompare(allowAiCallValue);

    if (currentCall === baselineCall) {
      formMethods.setValue(
        COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_USER.api_name,
        baselineAllowAiCallUpdatedUserRef.current,
        {shouldDirty: true, shouldTouch: false}
      );
      formMethods.setValue(
        COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_AT.api_name,
        baselineAllowAiCallUpdatedAtRef.current,
        {shouldDirty: true, shouldTouch: false}
      );
      return;
    }

    const un = props.user?.username ?? props.user?.userName;
    const displayName = `${un?.firstName || ''} ${un?.lastName || ''}`.trim();
    const updatedAtDateOnly = formatAllowAiCallUpdatedAtDisplay(new Date().toISOString());
    formMethods.setValue(COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_USER.api_name, displayName, {
      shouldDirty: true,
      shouldTouch: false,
    });
    formMethods.setValue(COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_AT.api_name, updatedAtDateOnly, {
      shouldDirty: true,
      shouldTouch: false,
    });
  }, [allowAiCallValue, props.user, formMethods]);

  const getCompanyData = ()=> {
    const initialData = props.tabProps?.companyData || {};
    return {...initialData, ...formMethods.getValues()};
  };
  const companyData = getCompanyData();

  // console.log('company data user');
  // console.log(props.user);
  // console.log(props);


  //console.log(companyData.inspectionLimits);

  const getDefaultValue = (field, parent = null) => {
    if (parent) {
      return companyData?.[parent]?.[field];
    }
    return companyData?.[field];
  };

  useEffect ( () => {
    setIsEditable(NewPermissionGate({
      user: props.user,
      elementPermissions: companyRules[COMPANY_ELEMENTS.editInspInfo],
    }));

  },[props.user]);

  const commonFieldProps = {
    fullWidth: true,
    maxWidth: '100%',
    isEditable: isEditable,
  };

  const InspLimitCollectionName = COMPANY_FIELDS.INSPECTION_LIMITS.api_name;

  const InspLimitRow = {
   [COMPANY_FIELDS.LIMIT_TYPES.api_name]: [],
   [COMPANY_FIELDS.JOB_TYPES.api_name]: [],
   [COMPANY_FIELDS.ALLOWED_DAYS.api_name]: [],
   [COMPANY_FIELDS.PER_DAY.api_name]: 0,
   [COMPANY_FIELDS.PER_WEEK.api_name]: 0,
  };

  const {fields, append} = useFieldArray({
    control: formMethods.control,
    name: InspLimitCollectionName,
  });

  //console.log('fields');
  //console.log(fields);


  const InspLimitSubformDefaultProps = (index, fieldName) => ({
    defaultValue: '' , //`${InspLimitCollectionName}[${index}].${fieldName}`,
    isEditable: true,
    nested: true,
    fullWidth: true,
    width: '100%',
    parent: `${InspLimitCollectionName}[${index}]`
  });

  //console.log('insp limit subform');
  //console.log(InspLimitSubformDefaultProps);


  const deleteInspLimitRow = (index) => {
    try {
      const inspLimitList = [...formMethods.getValues()?.[allConstants.COMPANY_FIELDS.INSPECTION_LIMITS.api_name]];
      inspLimitList.splice(index, 1);
      formMethods.setValue(allConstants.COMPANY_FIELDS.INSPECTION_LIMITS.api_name, inspLimitList);
    } catch(e){

    }
  };

  return (
    <>
      <Grid container maxWidth={'100%'} spacing={3}>
        <NotAllowedToEditSection show={props.tabProps.notAllowedToEdit}/> 
        <Grid item sm={12} flex={1}>
          <Card className={classes.card_block}>
            <CardContent sx={{pb: 0, '&:last-child': {pb: 0}}}>
              <Box>
                <Typography className={classes.eq_name}>{COMPANY_FIELDS.INSPECTION_SECTION.label}</Typography>
              </Box>
              <Box display={'flex'} gap={2} alignItems={'flex-start'}>
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.CITY_INSPECTION}
                  inputType={inputTypes.checkbox}
                  disabled={!isEditable}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.CITY_INSPECTION.api_name)}
                />
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.HERS_REQUIRE_INSPECTION}
                  inputType={inputTypes.checkbox}
                  disabled={!isEditable}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.HERS_REQUIRE_INSPECTION.api_name)}
                />
                <Box flex={1} minWidth={0}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    field={COMPANY_FIELDS.AUTO_HOLD}
                    inputType={inputTypes.multiSelect}
                    options={Utils.getOptions(AUTO_HOLD_JOB_TYPES)}
                    disabled={!isEditable}
                    width={'100%'}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.AUTO_HOLD.api_name)}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} flex={1}>
          <Card className={classes.card_block}>
            <CardContent sx={{pb: 0, '&:last-child': {pb: 0}}}>
              <Box sx={{mb: '2px'}}>
                <Typography className={classes.eq_name}>{COMPANY_FIELDS.AI_SECTION.label}</Typography>
              </Box>
              <Box display={'flex'} gap={2} alignItems={'flex-start'}>
                <Box sx={{flexShrink: 0, width: '140px'}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    maxWidth="140px"
                    field={COMPANY_FIELDS.ALLOW_AI_CALL}
                    inputType={inputTypes.singleSelect}
                    noneStoresUndefined
                    options={Utils.getOptions(allConstants.COMPANY_OPTIONS[COMPANY_FIELDS.ALLOW_AI_CALL.api_name])}
                    disabled={!isEditable}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOW_AI_CALL.api_name)}
                  />
                </Box>
                <Box sx={{flexShrink: 0, width: '140px'}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    maxWidth="140px"
                    field={COMPANY_FIELDS.CALLBACK_DAYS}
                    inputType={inputTypes.singleSelect}
                    noneStoresUndefined
                    options={Utils.getOptions(allConstants.COMPANY_OPTIONS[COMPANY_FIELDS.CALLBACK_DAYS.api_name])}
                    disabled={!isEditable}
                    defaultValue={resolveCallbackDaysValue(getDefaultValue(COMPANY_FIELDS.CALLBACK_DAYS.api_name))}
                  />
                </Box>
                <Box sx={{flexShrink: 0, width: '180px'}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    maxWidth="180px"
                    field={COMPANY_FIELDS.MAX_NO_ANSWER_ATTEMPTS}
                    inputType={inputTypes.singleSelect}
                    noneStoresUndefined
                    options={Utils.getOptions(allConstants.COMPANY_OPTIONS[COMPANY_FIELDS.MAX_NO_ANSWER_ATTEMPTS.api_name])}
                    disabled={!isEditable}
                    defaultValue={resolveMaxNoAnswerAttemptsValue(getDefaultValue(COMPANY_FIELDS.MAX_NO_ANSWER_ATTEMPTS.api_name))}
                  />
                </Box>
                <Box sx={{flex: 1, minWidth: 0, maxWidth: 320}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    field={COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_USER}
                    isEditable={false}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_USER.api_name) ?? ''}
                  />
                </Box>
                <Box sx={{flex: 1, minWidth: 0, maxWidth: 320}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    field={COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_AT}
                    isEditable={false}
                    defaultValue={Utils.formatIsoDateString(getDefaultValue(COMPANY_FIELDS.ALLOW_AI_CALL_UPDATED_AT.api_name), {date: true})}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} flex={1}  >
          <Card className={classes.card_block}>
            <CardContent>
              <Box>
                <Typography className={classes.eq_name}>{COMPANY_FIELDS.INSPECTION_LIMITS.label}</Typography>
              </Box>
              <form>
                <List>
                  {fields.map((item, index) => (
                    <ListItem key={item.id} sx={{
                      display: 'grid',
                      paddingTop: '0',
                      paddingBottom: '0',
                      gridTemplateColumns: '140px 1fr 1fr 70px 70px 70px',
                      gap: '8px',
                      alignItems: 'flex-start'
                    }}>
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.LIMIT_TYPES.api_name)}
                        field={COMPANY_FIELDS.LIMIT_TYPES}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(INSPECTION_LIMIT_TYPES)}
                        disabled={!isEditable}
                        defaultValue={item.limitTypes}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.JOB_TYPES.api_name)}
                        field={{...COMPANY_FIELDS.JOB_TYPES, ...{required: false}}}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(JOB_TYPES)}
                        disabled={!isEditable}
                        defaultValue={item.jobTypes}
                        //defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_DAYS.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.ALLOWED_DAYS.api_name)}
                        field={COMPANY_FIELDS.ALLOWED_DAYS}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(DAYS_OF_WEEK)}
                        disabled={!isEditable}
                        defaultValue={item.allowedDays}
                        //defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_DAYS.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      <CustomFormBlock
                          {...props.inputDefaultProps}
                          {...commonFieldProps}
                          {...InspLimitSubformDefaultProps(index)}
                          field={COMPANY_FIELDS.PER_DAY}
                          isEditable={isEditable}
                          //defaultValue={getDefaultValue(COMPANY_FIELDS.PER_DAY.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}s
                      />
                      <CustomFormBlock
                          {...props.inputDefaultProps}
                          {...commonFieldProps}
                          {...InspLimitSubformDefaultProps(index)}
                          field={COMPANY_FIELDS.PER_WEEK}
                          isEditable={isEditable}
                          //defaultValue={getDefaultValue(COMPANY_FIELDS.PER_WEEK.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      {!props.inputDefaultProps.viewMode && isEditable  && <DeleteEquipmentRowButton eqName={'inspLimit'}
                        extraStyles={{alignSelf: 'baseline',
                          top: '8px',
                          position: 'relative',
                          padding: '0'
                        }}
                        deleteAction={() => deleteInspLimitRow(index)}
                      />}
                    </ListItem>)
                  )}
                </List>
                {!props.inputDefaultProps.viewMode && isEditable &&
                <AddRowButton eqName={'inspLimit'} variant={variants.textWithIcon}
                  addAction={() => {
                    append({...InspLimitRow});
                  }}
                />}
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

CompanyInspectionInfo.propTypes = companyPropTypes;
CompanyInspectionInfo.defaultProps = companyDefaultProps;
